import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.5rem;
  background-color: ${({ theme }) => theme.colors.gray8};
`;
